import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface GuttersFasciaDownspoutDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GuttersFasciaDownspoutDescription: React.FC<GuttersFasciaDownspoutDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [guttersFasciaDownspoutDescription, set_guttersFasciaDownspoutDescription] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Guters or Fascia, Downspout']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Guters or Fascia, Downspout': [v, b.values?.['Exterior Structure']?.['Guters or Fascia, Downspout']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={guttersFasciaDownspoutDescription}
                />
            ) : (
                <TextBox
                    value={guttersFasciaDownspoutDescription}
                    onChange={(value) => set_guttersFasciaDownspoutDescription(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
